module.exports = __webpack_public_path__ + "img/about_csv_template_01.06e675c2.png";